export default {
  namespaced: true,
  state: {
    showMyReports: true,
  },
  mutations: {
    SET_SHOW_MY_REPORTS(state, value) {
      state.showMyReports = value;
    },
  },
  actions: {
    setShowMyReports({ commit }, value) {
      commit('SET_SHOW_MY_REPORTS', value);
    },
  },
};
